import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import balanceIcon from '../assets/select-brand-balance-icon.png'
import { REWARDS_BALANCE_MIN_LINE } from '../lib/rewards-copy'
import { formatUsd } from '../lib/profileStepUtils'
import {
  rewardsBalanceAmountSx,
  rewardsBalanceCardSx,
  rewardsBalanceIconSx,
  rewardsBalanceMinSx,
} from '../styles/rewardsPageStyles'

interface Props {
  readonly balanceUsd: number
  readonly testId?: string
}

export function RewardsBalanceHighlightCard({
  balanceUsd,
  testId = 'rewards-balance-card',
}: Readonly<Props>) {
  return (
    <Box sx={rewardsBalanceCardSx} data-testid={testId}>
      <Box>
        <Typography sx={rewardsBalanceAmountSx} component="p">
          {`You Balance ${formatUsd(balanceUsd)}!`}
        </Typography>
        {REWARDS_BALANCE_MIN_LINE ? (
          <Typography sx={rewardsBalanceMinSx}>{REWARDS_BALANCE_MIN_LINE}</Typography>
        ) : null}
      </Box>
      <Box component="img" src={balanceIcon} alt="" sx={rewardsBalanceIconSx} aria-hidden />
    </Box>
  )
}
